module.exports = __webpack_public_path__ + "img/artist-derek.4d65fbf9.jpg";